import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { getUpdateData, createExpress } from "../services/API";
import socket from "../assets/js/socket";
import axios from "axios";
import "../assets/css/usuarios.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

import {
    Container,
    Grid,
    Typography,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    FormControlLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    CssBaseline,
    List,
    ListItem,
    ListItemText,
} from "@mui/material";
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
}));

const NegativizarExpress = () => {
    const [selectedFunction, setSelectedFunction] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [tituloInformacion, setTituloInformacion] = useState("");
    const [dataAdgroups, setDataAdgroups] = useState([]);
    const [dataCampaign, setDataCampaign] = useState([]);
    const [dataPortafolios, setDataPortafolios] = useState([]);
    const [dataProductos, setDataProductos] = useState([]);
    const [copiesRealTime, setCopiesRealTime] = useState({});
    const navigate = useNavigate();
    const [parametros, setParametros] = useState([]);
    const [parametroInput, setParametroInput] = useState("");
    const [activeSubmenuFilterExpress, setActiveSubmenuFilterExpress] = useState({ type: "ALL", value: null });
    const [submenuSearchValueExpress, setSubmenuSearchValueExpress] = useState("");

    const handleAddParametros = () => {
        if (parametroInput.trim() === "") {
            alertify.notify("No hay términos por añadir", "error", 5);
            return;
        }

        const nuevosParametros = parametroInput
            .split(",")
            .map((parametro) => parametro.trim())
            .filter(Boolean)
            .map((parametro) => ({
                id: Math.random().toString(16).slice(2),
                nombre: parametro,
                coincidencia: "Negative Exact",
            }));
        setParametros([...parametros, ...nuevosParametros]);
        setParametroInput("");
        alertify.notify("Términos añadidos", "success", 5);
    };

    const handleDeleteParametro = (id) => {
        setParametros(parametros.filter((parametro) => parametro.id !== id));
        alertify.notify("Término eliminado", "error", 5);
    };

    const handleCoincidenciaChange = (id, value) => {
        setParametros(
            parametros.map((parametro) =>
                parametro.id === id ? { ...parametro, coincidencia: value } : parametro
            )
        );
    };

    const handleFilterClick = (filtro) => {
        if (filtro === "ALL") {
            setActiveSubmenuFilterExpress({ type: "ALL", value: null });
        } else if (filtro === "ENABLED" || filtro === "PAUSED") {
            setActiveSubmenuFilterExpress({ type: "STATE", value: filtro });
        }
    };

    const getDataRealTime = (response) => {
        const campaigns = response.data.campaigns
            .filter(campaign => campaign.state !== "ARCHIVED")
            .map(campaign => ({
                ...campaign,
                adGroups: (campaign.adGroups || []).filter(group => group.state !== "ARCHIVED")
            }));

        const productos = response.data.productos.map(producto => ({
            ...producto,
            campaigns: producto.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(producto => producto.campaigns.length > 0 && producto.state !== "ARCHIVED")

        const portafolios = response.data.portfolios.map(portafolio => ({
            ...portafolio,
            campaigns: portafolio.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(portafolio => portafolio.campaigns.length > 0 && portafolio.state !== "ARCHIVED")

        const asinMap = new Map();

        productos.forEach(producto => {
            const { asin, campaigns = [] } = producto;

            if (!asinMap.has(asin))
                asinMap.set(asin, { ...producto, campaigns: [...campaigns] });
            else {
                const existente = asinMap.get(asin);
                const campaignIdsExistentes = new Set(existente.campaigns.map(c => c.campaignId));
                campaigns.forEach(campaign => {
                    if (!campaignIdsExistentes.has(campaign.campaignId)) {
                        existente.campaigns.push(campaign);
                        campaignIdsExistentes.add(campaign.campaignId);
                    }
                });
                asinMap.set(asin, existente);
            }
        });

        const resultadoFinal = Array.from(asinMap.values());

        setDataAdgroups(campaigns);
        setDataProductos(resultadoFinal);
        setDataCampaign(campaigns);
        setDataPortafolios(portafolios);
        setCopiesRealTime({
            adgroups: campaigns,
            campaigns: campaigns,
            portafolios: portafolios,
            productos: resultadoFinal
        });
    }

    useEffect(() => {
        (async () => {
            const accountID = localStorage.getItem("selectedAccountValue");
            const response = await getUpdateData(accountID);
            getDataRealTime(response);
        })();
    }, []);

    const notifyBOT = async () => {
        await axios.get("https://bot.jungleclick.online");
        console.log("BOT notificado.");
    }

    useEffect(() => {
        const handleConnect = () => {
            console.log("✅ Conectado al servidor WebSocket:", socket.id);
            notifyBOT();
        };

        const handleUpdate = (data) => {
            console.log("🔄 Actualización recibida:", data);
            const account = localStorage.getItem("selectedAccountValue");
            if (data.data.accountId == account)
                getDataRealTime(data.data.data);
            else
                console.log("Actualización omitida");
        };

        socket.on("connect", handleConnect);
        socket.on("update", handleUpdate);

        return () => {
            socket.off("connect", handleConnect);
            socket.off("update", handleUpdate);
        };
    }, []);

    const [checkboxes, setCheckboxes] = useState({});
    const [isOpen, setIsOpen] = useState({});

    const generarDestiny = (data, tipo) => {
        if (Object.keys(checkboxes).length === 0)
            return "No se ha seleccionado ningún destino.";
        const idsSeleccionados = Object.keys(checkboxes).filter(id => checkboxes[id]);
        const portafolios = copiesRealTime.portafolios;
        const campanas = copiesRealTime.campaigns;
        const dataProductos = copiesRealTime.productos;
        if (idsSeleccionados.length === 0)
            return "No se ha seleccionado ningún destino.";
        else {
            switch (tipo) {
                case "Adgroups":
                    const campaignsFormateadas = [];
                    for (const campaign of campanas) {
                        const adGroupsFiltrados = campaign.adGroups?.filter(ad => idsSeleccionados.includes(ad.adGroupId));

                        if (adGroupsFiltrados && adGroupsFiltrados.length > 0) {
                            campaignsFormateadas.push({
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" :
                                    campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: adGroupsFiltrados.map(ad => ({
                                    adGroupId: ad.adGroupId,
                                    adGroupName: ad.name
                                }))
                            });
                        }
                    }
                    data.destinations = { campaigns: campaignsFormateadas };
                    break;
                case "Campaigns":
                    const campaignsSeleccionadas = [];
                    for (const campaign of campanas) {
                        if (idsSeleccionados.includes(campaign.campaignId)) {
                            campaignsSeleccionadas.push({
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" :
                                    campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: campaign.adGroups?.map(ad => ({
                                    adGroupId: ad.adGroupId,
                                    adGroupName: ad.name
                                })) || []
                            });
                        }
                    }
                    data.destinations = { campaigns: campaignsSeleccionadas };
                    break;
                case "Portafolios":
                    const portfoliosFormateados = [];
                    for (const portfolio of portafolios) {
                        if (idsSeleccionados.includes(portfolio.portfolioId)) {
                            const campaignsFormateadas = campanas
                                .filter(campaign => campaign.portfolioId === portfolio.portfolioId)
                                .map(campaign => ({
                                    campaignId: campaign.campaignId,
                                    campaignName: campaign.name,
                                    type: campaign.type === "SP" ? "Sponsored Products" :
                                        campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                    adGroups: (campaign.adGroups || []).map(ad => ({
                                        adGroupId: ad.adGroupId,
                                        adGroupName: ad.name
                                    }))
                                }));
                            portfoliosFormateados.push({
                                portfolioId: portfolio.portfolioId,
                                portfolioName: portfolio.name,
                                campaigns: campaignsFormateadas
                            });
                        }
                    }
                    data.destinations = { portfolios: portfoliosFormateados };
                    break;
                case "Asins":
                    const productosFormateados = [];
                    for (const producto of dataProductos) {
                        if (idsSeleccionados.includes(producto.adId)) {
                            const campaign = campanas.find(c => c.campaignId === producto.campaignId);
                            const adGroup = campaign?.adGroups?.find(ad => ad.adGroupId === producto.adGroupId);
                            const campaignFormateada = campaign ? {
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" :
                                    campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: adGroup ? [{
                                    adGroupId: adGroup.adGroupId,
                                    adGroupName: adGroup.name
                                }] : []
                            } : null;
                            productosFormateados.push({
                                asin: producto.asin,
                                sku: producto.sku,
                                state: producto.state,
                                campaigns: campaignFormateada ? [campaignFormateada] : []
                            });
                        }
                    }
                    data.destinations = { asins: productosFormateados };
                    break;
                default:
                    break;
            }
            return "";
        }
    };

    const handleSave = async () => {
        const recogerDatosFormulario = () => {
            const datos = {
                destino: selectedFunction
            };

            if (!datos.destino) {
                alertify.notify("El campo Destino es obligatorio.", "error", 5);
                return null;
            }
            return datos;
        }

        const data = recogerDatosFormulario();
        if (!data) return;

        const errorMessage = generarDestiny(data, selectedFunction);
        if (errorMessage !== "") {
            alertify.notify(errorMessage, "error", 5);
            return;
        }

        const tablaData = parametros.map(parametro => ({
            termino: parametro.nombre,
            tipo: parametro.coincidencia
        }));
        data.parametrosTabla = tablaData;
        data.unique = Math.random().toString(16).slice(2);
        const accountID = localStorage.getItem("selectedAccountValue");
        console.log("destinations:", data.destinations);
        const response = await createExpress(data, accountID);
        (response.error) ? alertify.notify(response.error, "error", 5) : alertify.notify("Terminos negativizados. Redirigiendo...", "success", 5);
        setTimeout(() => navigate("/listas"), 2000);
    };

    const handleCancel = () => navigate("/calendario");

    const handleSelectAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = true);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = true;
                });
            }
            else if (selectedFunction === "Portafolios") {
                dataPortafolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = true;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = true;
                });
            }
            return newState;
        });
    };

    const handleClearAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = false);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = false;
                });
            }
            else if (selectedFunction === "Portafolios") {
                dataPortafolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = false;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = false;
                });
            }
            return newState;
        });
    };

    const toggleOpen = (itemId) => setIsOpen((prev) => ({ ...prev, [itemId]: !prev[itemId] }));

    const handleCheckboxChange = (id) => {
        setCheckboxes((prev) => {
            return {
                ...prev,
                [id]: !prev[id]
            };
        });
    };

    const handleFunctionSelect = (option) => {
        if (selectedFunction === "" || selectedFunction.trim() === "")
            changeDestination(option);
        else
            alertify.confirm("Cambio de destino", "¿Se perderán los checkboxes del destino actual, desea continuar?", () => {
                changeDestination(option);
            }, () => alertify.error("Operación cancelada"));
    };

    const changeDestination = (option) => {
        setSelectedFunction(option);
        setShowForm(true);
        setTituloInformacion(option);
        setCheckboxes({});

        setActiveSubmenuFilterExpress({ type: "ALL", value: null });
        setSubmenuSearchValueExpress("");
    };

    useEffect(() => {
        if (!copiesRealTime || Object.keys(copiesRealTime).length === 0 || !selectedFunction || selectedFunction === "") {
            setDataAdgroups([]);
            setDataCampaign([]);
            setDataPortafolios([]);
            setDataProductos([]);
            return;
        }

        let baseDataForSubmenu;
        switch (selectedFunction) {
            case "Adgroups":
                baseDataForSubmenu = copiesRealTime.adgroups ? [...copiesRealTime.adgroups] : [];
                break;
            case "Campaigns":
                baseDataForSubmenu = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : [];
                break;
            case "Portafolios":
                baseDataForSubmenu = copiesRealTime.portafolios ? [...copiesRealTime.portafolios] : [];
                break;
            case "Asins":
                baseDataForSubmenu = copiesRealTime.productos ? [...copiesRealTime.productos] : [];
                break;
            default:
                baseDataForSubmenu = [];
        }

        let filteredByDropdown = baseDataForSubmenu;

        if (activeSubmenuFilterExpress.type === "STATE") {
            const filterStateValue = activeSubmenuFilterExpress.value;
            if (selectedFunction === "Adgroups") {
                filteredByDropdown = baseDataForSubmenu.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => adgroup.state === filterStateValue)
                })).filter(campaign => campaign.adGroups.length > 0);
            } else if (selectedFunction === "Campaigns" || selectedFunction === "Portafolios") {
                filteredByDropdown = filteredByDropdown.filter(item => item.state === filterStateValue);
            } else if (selectedFunction === "Asins") {
                if (activeSubmenuFilterExpress.value) {
                    alertify.notify("Los Asins no tienen un filtro de estado ENABLED o PAUSED directo en esta vista.", "warning", 5);
                }
            }
        }

        let finalFilteredDataForPanel = filteredByDropdown;

        if (submenuSearchValueExpress.trim() !== "") {
            const searchTermLower = submenuSearchValueExpress.toLowerCase();
            const matchesSearch = (name) => String(name || "").toLowerCase().includes(searchTermLower);

            if (selectedFunction === "Adgroups") {
                finalFilteredDataForPanel = filteredByDropdown.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => matchesSearch(adgroup.name))
                })).filter(campaign => campaign.adGroups.length > 0);
            } else if (selectedFunction === "Campaigns") {
                finalFilteredDataForPanel = filteredByDropdown.filter(campaign => matchesSearch(campaign.name));
            } else if (selectedFunction === "Portafolios") {
                finalFilteredDataForPanel = filteredByDropdown.filter(portafolio => matchesSearch(portafolio.name || "Sin Portafolio"));
            } else if (selectedFunction === "Asins") {
                finalFilteredDataForPanel = filteredByDropdown.filter(asin => matchesSearch(asin.asin || "Sin Asin"));
            }
        }

        switch (selectedFunction) {
            case "Adgroups":
                setDataAdgroups(finalFilteredDataForPanel);
                break;
            case "Campaigns":
                setDataCampaign(finalFilteredDataForPanel);
                break;
            case "Portafolios":
                setDataPortafolios(finalFilteredDataForPanel);
                break;
            case "Asins":
                setDataProductos(finalFilteredDataForPanel);
                break;
            default:
                setDataAdgroups([]);
                setDataCampaign([]);
                setDataPortafolios([]);
                setDataProductos([]);
        }

    }, [copiesRealTime, selectedFunction, activeSubmenuFilterExpress, submenuSearchValueExpress]);


    return (
        <Layout>
            <div className="app-container">
                <CssBaseline />
                <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                    <Grid container spacing={3} wrap="nowrap">
                        <Grid sx={{ width: '40%' }}>
                            <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} fullWidth>
                                    <Typography variant="h4" component="h1">
                                        Negativizador Express
                                    </Typography>
                                    <Button variant="contained" color="error" onClick={handleCancel}>
                                        Cancelar
                                    </Button>
                                </Box>

                                <FormControl fullWidth sx={{ mb: 3 }}>
                                    <InputLabel id="destination-select-label">Destino</InputLabel>
                                    <Select
                                        labelId="destination-select-label"
                                        id="destination-select"
                                        value={selectedFunction}
                                        label="Destino"
                                        onChange={(e) => handleFunctionSelect(e.target.value)}
                                    >
                                        <MenuItem value="">
                                            <em>Seleccione una opción</em>
                                        </MenuItem>
                                        <MenuItem value="Adgroups">Adgroups</MenuItem>
                                        <MenuItem value="Campaigns">Campaigns</MenuItem>
                                        <MenuItem value="Portafolios">Portafolios</MenuItem>
                                        <MenuItem value="Asins">Asins</MenuItem>
                                    </Select>
                                </FormControl>

                                {showForm && (
                                    <Box>
                                        <Typography variant="h6" gutterBottom>
                                            Términos a negativizar:
                                        </Typography>
                                        <Grid container spacing={2} alignItems="center" mb={3} mt={2}>
                                            <Grid sx={{ width: '70%' }}>
                                                <TextField
                                                    fullWidth
                                                    label="Ingrese los términos separados por comas"
                                                    variant="outlined"
                                                    value={parametroInput}
                                                    onChange={(e) => setParametroInput(e.target.value)}
                                                />
                                            </Grid>
                                            <Grid sx={{ width: '20%' }}>
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleAddParametros}
                                                    sx={{ height: '40px' }}
                                                >
                                                    Añadir
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {parametros.length > 0 && (
                                    <Box mb={3}>
                                        <Table component={Paper} elevation={1}>
                                            <TableHead sx={{ backgroundColor: 'primary.main' }}>
                                                <TableRow>
                                                    <TableCell sx={{ color: 'white' }}>Término</TableCell>
                                                    <TableCell sx={{ color: 'white' }}>Tipo</TableCell>
                                                    <TableCell sx={{ color: 'white' }}>Acción</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {parametros.map((parametro) => (
                                                    <TableRow key={parametro.id}>
                                                        <TableCell>{parametro.nombre}</TableCell>
                                                        <TableCell>
                                                            <FormControl fullWidth size="small">
                                                                <Select
                                                                    value={parametro.coincidencia}
                                                                    onChange={(e) =>
                                                                        handleCoincidenciaChange(parametro.id, e.target.value)
                                                                    }
                                                                >
                                                                    <MenuItem value="Negative Exact">Negative Exact</MenuItem>
                                                                    <MenuItem value="Negative Phrase">Negative Phrase</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button
                                                                variant="outlined"
                                                                color="error"
                                                                onClick={() => handleDeleteParametro(parametro.id)}
                                                            >
                                                                Eliminar
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Box display="flex" justifyContent="center" mt={3}>
                                            <Button variant="contained" color="success" onClick={handleSave}>
                                                Guardar
                                            </Button>
                                        </Box>
                                    </Box>
                                )}
                            </Paper>
                        </Grid>

                        <Grid sx={{ width: '60%' }}>
                            <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                <Grid container spacing={2} alignItems="center" mb={2}>
                                    <Grid item xs={8}>
                                        <TextField
                                            fullWidth
                                            label="Buscar..."
                                            variant="outlined"
                                            value={submenuSearchValueExpress}
                                            onChange={(e) => setSubmenuSearchValueExpress(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl fullWidth>
                                            <InputLabel id="filter-by-label">Filtrar por</InputLabel>
                                            <Select
                                                labelId="filter-by-label"
                                                value={activeSubmenuFilterExpress.value || "ALL"}
                                                label="Filtrar por"
                                                onChange={(e) => handleFilterClick(e.target.value)}
                                            >
                                                <MenuItem value="ALL">Sin Filtro</MenuItem>
                                                <MenuItem value="ENABLED">State Enabled</MenuItem>
                                                <MenuItem value="PAUSED">State Paused</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <Typography variant="h5" sx={{ my: 2 }}>{tituloInformacion}</Typography>

                                {selectedFunction !== "" && (
                                    <Box mb={2}>
                                        <StyledButton variant="contained" onClick={handleSelectAll}>
                                            Seleccionar todo
                                        </StyledButton>
                                        <StyledButton variant="outlined" color="error" onClick={handleClearAll}>
                                            Limpiar todo
                                        </StyledButton>
                                    </Box>
                                )}

                                <Box sx={{ maxHeight: 600, overflowY: 'auto' }}>
                                    {selectedFunction === "Adgroups" && dataAdgroups.map((campaign) => (
                                        <Accordion
                                            key={campaign.campaignId}
                                            expanded={isOpen[campaign.campaignId] || false}
                                            onChange={() => toggleOpen(campaign.campaignId)}
                                            sx={{ mb: 1 }}
                                            TransitionProps={{ timeout: 0 }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<FontAwesomeIcon icon={isOpen[campaign.campaignId] ? faChevronUp : faChevronDown} />}
                                                aria-controls={`panel-${campaign.campaignId}-content`}
                                                id={`panel-${campaign.campaignId}-header`}
                                            >
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                                    <Typography variant="subtitle1" sx={{ width: '70%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        Campaña: {campaign.name.replaceAll("_", " ")}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', ml: 2, width: '20%' }}>
                                                        State: {campaign.state}
                                                        <br />
                                                        Type: {campaign.type}
                                                    </Typography>
                                                </Box>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <List dense>
                                                    {campaign.adGroups.map((adgroup) => (
                                                        <ListItem
                                                            key={adgroup.adGroupId}
                                                            secondaryAction={
                                                                <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
                                                                    Status: {adgroup.state}
                                                                </Typography>
                                                            }
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={checkboxes?.[adgroup.adGroupId] || false}
                                                                        onChange={() => handleCheckboxChange(adgroup.adGroupId)}
                                                                    />
                                                                }
                                                                label={`AdGroup: ${adgroup.name.replaceAll("_", " ")}`}
                                                            />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}

                                    {selectedFunction === "Campaigns" && dataCampaign.map((campaign) => (
                                        <Accordion
                                            key={campaign.campaignId}
                                            expanded={isOpen[campaign.campaignId] || false}
                                            onChange={() => toggleOpen(campaign.campaignId)}
                                            sx={{ mb: 1 }}
                                            TransitionProps={{ timeout: 0 }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<FontAwesomeIcon icon={isOpen[campaign.campaignId] ? faChevronUp : faChevronDown} />}
                                                aria-controls={`panel-${campaign.campaignId}-content`}
                                                id={`panel-${campaign.campaignId}-header`}
                                            >
                                                <FormControlLabel
                                                    aria-label="Acknowledge"
                                                    onClick={(event) => event.stopPropagation()}
                                                    onFocus={(event) => event.stopPropagation()}
                                                    control={
                                                        <Checkbox
                                                            checked={checkboxes?.[campaign.campaignId] || false}
                                                            onChange={() => handleCheckboxChange(campaign.campaignId)}
                                                        />
                                                    }
                                                    label={
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                                            <Typography variant="subtitle1" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                Campaña: {campaign.name.replaceAll("_", " ")}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', ml: 2 }}>
                                                                State: {campaign.state}
                                                                <br />
                                                                Type: {campaign.type}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                />
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <List dense>
                                                    {campaign.adGroups.map((adgroup) => (
                                                        <ListItem
                                                            key={adgroup.adGroupId}
                                                            secondaryAction={
                                                                <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
                                                                    Status: {adgroup.state}
                                                                </Typography>
                                                            }
                                                        >
                                                            <ListItemText primary={`AdGroup: ${adgroup.name.replaceAll("_", " ")}`} />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}

                                    {selectedFunction === "Portafolios" && dataPortafolios.map((portafolio) => (
                                        <Accordion
                                            key={portafolio.portfolioId}
                                            expanded={isOpen[portafolio.portfolioId] || false}
                                            onChange={() => toggleOpen(portafolio.portfolioId)}
                                            sx={{ mb: 1 }}
                                            TransitionProps={{ timeout: 0 }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<FontAwesomeIcon icon={isOpen[portafolio.portfolioId] ? faChevronUp : faChevronDown} />}
                                                aria-controls={`panel-${portafolio.portfolioId}-content`}
                                                id={`panel-${portafolio.portfolioId}-header`}
                                            >
                                                <FormControlLabel
                                                    aria-label="Acknowledge"
                                                    onClick={(event) => event.stopPropagation()}
                                                    onFocus={(event) => event.stopPropagation()}
                                                    control={
                                                        <Checkbox
                                                            checked={checkboxes?.[portafolio.portfolioId] || false}
                                                            onChange={() => handleCheckboxChange(portafolio.portfolioId)}
                                                        />
                                                    }
                                                    label={
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                                            <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
                                                                Portafolio: {portafolio.name.replaceAll("_", " ")}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', ml: 2 }}>
                                                                State: {portafolio.state}
                                                            </Typography>
                                                        </Box>
                                                    }
                                                />
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <List dense>
                                                    {portafolio.campaigns.map((campaign) => (
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                                            <Typography variant="subtitle1" sx={{ width: '70%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                Campaña: {campaign.name.replaceAll("_", " ")}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', ml: 2, width: '20%' }}>
                                                                State: {campaign.state}
                                                                <br />
                                                                Type: {campaign.type}
                                                            </Typography>
                                                            <br />
                                                            <br />
                                                        </Box>
                                                    ))}
                                                </List>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}

                                    {selectedFunction === "Asins" && dataProductos.map((producto) => (
                                        <Accordion
                                            key={producto.adId}
                                            expanded={isOpen[producto.adId] || false}
                                            onChange={() => toggleOpen(producto.adId)}
                                            sx={{ mb: 1 }}
                                            TransitionProps={{ timeout: 0 }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<FontAwesomeIcon icon={isOpen[producto.adId] ? faChevronUp : faChevronDown} />}
                                                aria-controls={`panel-${producto.adId}-content`}
                                                id={`panel-${producto.adId}-header`}
                                            >
                                                <FormControlLabel
                                                    aria-label="Acknowledge"
                                                    onClick={(event) => event.stopPropagation()}
                                                    onFocus={(event) => event.stopPropagation()}
                                                    control={
                                                        <Checkbox
                                                            checked={checkboxes?.[producto.adId] || false}
                                                            onChange={() => handleCheckboxChange(producto.adId)}
                                                        />
                                                    }
                                                    label={
                                                        <Typography variant="subtitle1">
                                                            ASIN: {typeof producto.asin === 'string' && producto.asin.trim() !== ''
                                                                ? producto.asin.replaceAll("_", " ")
                                                                : "ASIN sin nombre"}
                                                        </Typography>
                                                    }
                                                />
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <List dense>
                                                    {producto.campaigns.map((campaign) => (
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                                            <Typography variant="subtitle1" sx={{ width: '70%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                Campaña: {campaign.name.replaceAll("_", " ")}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', ml: 2, width: '20%' }}>
                                                                State: {campaign.state}
                                                                <br />
                                                                Type: {campaign.type}
                                                            </Typography>
                                                            <br />
                                                            <br />
                                                        </Box>
                                                    ))}
                                                </List>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </Layout>
    );
};

export default NegativizarExpress;